import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import Page from 'src/components/molecules/page';
import { FrameForm } from 'src/components/organisms/reservation-frame/form';

export const PhotoStudioFrameCreatePage: FC = () => {
  /* 定数宣言 */
  const title = '予約枠登録';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <FrameForm />
      </Container>
    </Page>
  );
};
